/* oxlint-disable no-console -- Use this logging system instead of console directly. */
export default ({ name = "hub" }: { name?: string } = {}) => {
  const prefix = `[${name}]`;
  return {
    // By binding directly to console methods, we preserve the original call
    // site in the console instead of showing this file as the source.
    debug: console.debug.bind(console, prefix),
    info: console.log.bind(console, prefix),
    error: console.error.bind(console, prefix),
    warn: console.warn.bind(console, prefix),
  };
};
